import Vue from "vue";

Vue.component("chart-column", {
	props: ["loading", "yAxisTitle", "chartTitle", "chartTitleAlignment", "chartData", "chartExporting", "hasLegend", 'hasStackLabels', 'isSps'],
	data() {
		return {
			hasData: true,
			footer: ""
		};
	},
	computed: {
		chartOptions: function () {
			const self = this;
			let labelsSettings = !self.hasStackLabels ? {} : {
					enabled: true,
					formatter: function () {
						return Math.round(this.total * Math.pow(10, 2)) / Math.pow(10, 2)
					},
					y: -1,
					padding: 2,
					style: {
						fontWeight: 'normal',
						fontSize: '10px'
					}
			};

			let spslegends = {
				enabled: self.hasLegend,
				reversed: true,
				width: 1000,
				itemWidth: 300

			}

			let defaultlegends = {
				enabled: self.hasLegend,
				reversed: true
			}

			return {
				styledMode: true,
				chart: {
					zoomType: "x", plotBackgroundColor: null, plotBorderWidth: null, plotShadow: false, type: "column"
				},
				title: { text: self.chartTitle, align: self.chartTitleAlignment },
				xAxis: { type: "category" },
				yAxis: { 
					allowDecimals: false, 
					min: 0, 
					title: { 
						text: self.yAxisTitle 
					},
					stackLabels: labelsSettings,
					labels: {
						enabled: false
					}
				},
				plotOptions: {
					column: { stacking: "normal" },

				},
				exporting: self.chartExporting ? self.chartExporting : {
					sourceWidth: 1200,
					buttons: { contextButton: { menuItems: ['downloadPNG'] } },
					chartOptions: {
						yAxis: {
							stackLabels: labelsSettings,
							labels: {
								enabled: false
							}
						}
					}
				},
				borderWidth: 0,
				legend: this.isSps ? spslegends : defaultlegends,
				series: self.chartData,
				credits:{
					enabled:false,
				}
			}
		}
	},
	template: `
		<div>
		    <wto-chart :loading="loading"
		                   :has-data="hasData"
		                   :chart-options="chartOptions"
		                   :footer="footer"></wto-chart>
		</div>
	`
});